import React from 'react';
import { map, sortBy } from 'lodash';
import { routes } from 'routes';
import { getAssetIcon } from 'helpers/icons';
import { allAssetTypeFilter } from 'helpers/filterHelper';
import featureConfigHelper from 'helpers/featureConfigHelper';
import UserCapabilityHelper from 'helpers/userCapabilityHelper';


export const getTabOptions = (translate, capabilities) => {
    const featureConfig = new featureConfigHelper();
    const userCapabilities = new UserCapabilityHelper(capabilities);
    const tabs = {
        cbm: {
            title: translate('ABB.Powertrain.Frontend.ptConditionMonitoringCBMTab'),
            route: routes.Cbm,
            disabled: true,
            hidden: featureConfig.isCBMFeatureEnabled()
        }
    };
    if (userCapabilities.hasConditionOverviewV2()) {
        tabs.conditionOverviewV2 = {
            title: `${translate('ABB.Powertrain.Frontend.conditionIndicesOverviewOverviewTitle')}`,
            route: routes.ConditionOverviewV2
        };
    }
    if (userCapabilities.hasAdvancedAnalyticsV2Capability()) {
        tabs.maintenanceOverviewV2 = {
            title: translate('ABB.Powertrain.Frontend.ptMaintenanceOverviewMainTab'),
            route: routes.MaintenanceOverviewV2,
            hidden: !featureConfig.isCBMFeatureEnabled()
        };
    }
    if (userCapabilities.hasCrossAssetAnalysisV2()) {
        tabs.crossAssetAnalysisV2 = {
            title: translate('ABB.Powertrain.Frontend.condMonitoringOverviewCrossAssetLabel'),
            route: routes.CrossKpiV2
        };
    }

    return tabs;
};

export const setOptions = (assets, translate) => {
    const options = [];

    const assetTypes = map(assets, (obj) => obj.componentType.typeName)
        .filter((item, index, arr) => arr.indexOf(item) === index);

    map(assetTypes, (assetType, indx) => {
        const label = translate(`ABB.Powertrain.Frontend.${assetType.toLowerCase()}Label`) || assetType;
        options.push({
            id: indx + 1,
            title: <>{getAssetIcon(assetType, { width: 16, height: 16 })} {label}</>,
            assetType,
            assetTypeLabel: label
        });
    });

    return [allAssetTypeFilter(translate), ...sortBy(options, [option => option?.assetTypeLabel])];
};
